<template>
    <MasterLayout>
         <div class="employees__assessment__wrapper">

             <div class="welcome_message">
                 <div class="row">
                     <div class="col-8">    
                         <h5 class=''><span class="greeeting__text"> Hi Admin,
                            </span> you have <span class="branches__count"> {{responsibilities.length}} </span> Responsibilities
                        </h5> 
                     </div>
                     <div class="col-4 text-right">
                        <div>
                            <button class="creaet_branch_btn" @click="openAddRespModal">Add Responsibility <i class="fa fa-plus ml-2"></i></button>
                        </div>
                     </div>
                 </div>
             </div>
             <section class="table__section mt-1 pb-5" v-show="!showLoader">
                <ejs-grid
                    ref="dataGrid"
                    :created="refreshGrid"
                    :allowPaging="true"
                    :allowSorting="true"
                    :pageSettings="pageSettings"
                    :toolbar="toolbar"
                    :searchSettings="search"
                    :allowExcelExport="true"
                    :allowPdfExport="true"
                    :toolbarClick="toolbarClick">
                    <e-columns>
                        <e-column field="index" headerText="#" width="60px"></e-column>
                        <e-column field="name" headerText="Responsibility Name"></e-column>
                        <e-column field="status" width="80px" :visible='false' headerText="Status"></e-column>
                        <e-column :template="deletedTemplate" width="150px" headerText="Status"></e-column>
                        <e-column :template="actionButtonsTemplate" width="150px" headerText="Actions"></e-column>
                    </e-columns>
                </ejs-grid>
            </section>
            <div class="empty_branch__div mt-3" v-if="responsibilities.length < 1 && !showLoader">
                <div class="text-center">
                    <h6 class="text-center"> You are yet to create a branch</h6>
                    <img src="@/assets/img/document.png" class="mt-3" width="130px" />
                </div>
            </div>
            <TableLoader v-show="showLoader" style="margin: 0 auto; width: 95%"></TableLoader>
            
            <AddResponsibilityModal></AddResponsibilityModal>
            <EditResponsibilityModal :responsibility = "responsibility"></EditResponsibilityModal>
         </div>
    </MasterLayout>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Admin/MasterLayout.vue";
import backgroundUrl from "@/assets/img/f6c324105a64e036f9e668224c23e501.jpg";
import UserDP from "@/assets/img/eben.jpeg";
import AddResponsibilityModal from '@/components/Modals/Responsibilities/addResponsibilities.vue';
import TableLoader from '@/components/TableLoading.vue';
import EditResponsibilityModal from '@/components/Modals/Responsibilities/editResponsibilities.vue';
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;


import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport
} from "@syncfusion/ej2-vue-grids";

export default {
    components: {
        MasterLayout,
        AddResponsibilityModal,
        EditResponsibilityModal,
        TableLoader
    },
    provide: {
        grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport]
    },
    data() {
        return {
            backgroundUrl,
            UserDP,
            componentKey: 0,
            responsibilities: [],
            responsibility: {},
            showLoader: false,
            pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
            toolbar: ["ExcelExport", "PdfExport", "Search"],
            search: { operator: "contains", ignoreCase: true },
            actionButtonsTemplate: function() {
                return {
                    template: Vue.component("actionButtonsTemplate", {
                        template:
                        '<div class="btn-group btn-group-sm" role="group">'+
                            '<button type="button" class="btn btn-primary" title="Edit" v-on:click="_editResp(data.id)">' +
                                '<i class="fa fa-edit" aria-hidden="true"></i>' +
                            '</button>' +
                            '<button type="button" class="btn btn-danger" title="Delete" v-on:click="_deleteResp(data.id)" v-if="data.deleted === false">' +
                                '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
                            '</button>' +
                            '<button type="button" class="btn btn-success" title="Re-Add" v-on:click="_readdeResp(data.id)" v-if="data.deleted === true">' +
                                '<i class="fa fa-plus" aria-hidden="true"></i>' +
                            '</button>' +
                        '</div>',
                        data: function() {
                            return {
                                data: {}
                            };
                        },
                        methods: {
                            _deleteResp: function(respId) {
                                this.$eventHub.$emit("deleteResp", respId, 0);
                            },
                            _readdeResp: function(respId) {
                                this.$eventHub.$emit("deleteResp", respId, 1);
                            },
                            _editResp: function(respId) {
                                console.log(respId);
                                this.$eventHub.$emit("editResp", respId);
                            }
                        }
                    })
                };
            },
            deletedTemplate: function(){
                return {
                    template: Vue.component("deletedTemplate", {
                        template: `<div><div v-if="data.deleted === true"><span class="badge badge-danger badge-pill">Deleted</span></div>
<div v-if="data.deleted === false"><span class="badge badge-success badge-pill">Active</span></div></div>`,
                        data: function() {
                            return {
                                data: {}
                            };
                        }
                    })
                }
            }
        }
    },
     mounted() {
        this.getresponsibilities();

        $(".e-input").keyup(function(e) {
            searchFun(e);
        });
        function searchFun(event) {
            var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
            var value = event.target.value;
            grid.search(value);
        }
    },
    created() {
        this.$eventHub.$on("deleteResp", (respId, type) => {
            this.deleteResp(respId, type);
        });
        this.$eventHub.$on("editResp", (respId) => {
            this.editResp(respId);
        });
        this.$eventHub.$on("refreshResponsilitiesTable", () => {
            this.getresponsibilities();
        });
        
    },
    methods: {
        toolbarClick(args) {
            switch (args.item.text) {
                case "PDF Export":
                    this.$refs.dataGrid.getColumns()[2].visible = true;
                    this.$refs.dataGrid.getColumns()[3].visible = false;
                    this.$refs.dataGrid.getColumns()[4].visible = false;

                    this.$refs.dataGrid.pdfExport({
                        fileName: 'Responsibilities.pdf',
                        theme: {
                        header: {
                            bold: true,
                            fontColor: "#000000",
                            fontName: 'Calibri',
                            fontSize: 10
                        },
                        record: {
                            fontColor: '#000000',
                            fontName: "Calibri",
                            fontSize: 8
                        }
                        },
                        header: {
                        fromTop:0,
                        height: 130,
                        contents:  [{
                            type: "Text",
                            value:  'Responsibilities',
                            position: {x:0, y: 50},
                            style: {fontSize: 20, textAlign: 'center'}
                            }],
                        },
                        footer: {
                            fromBottom: 130,
                            height: 130,
                            contents:  [{
                            type: "Text",
                            value: "Thank You",
                            position: {x:0, y: 50},
                            style: {fontSize: 20}
                            }],
                        
                        }
                    });
                break;
                case "Excel Export":
                    this.$refs.dataGrid.getColumns()[2].visible = true;
                    this.$refs.dataGrid.getColumns()[3].visible = false;
                    this.$refs.dataGrid.getColumns()[4].visible = false;
                    this.$refs.dataGrid.excelExport({
                        fileName: 'Responsibilities.xlsx',
                        theme: {
                        header: {
                            bold: true,
                            fontColor: "#000000",
                            fontName: 'Calibri',
                            fontSize: 10
                        },
                        record: {
                            fontColor: '#000000',
                            fontName: "Calibri",
                            fontSize: 8
                        }
                        },
                        header: {
                        fromTop:0,
                        height: 130,
                        contents:  [{
                            type: "Text",
                            value:  `Responsibilities`,
                            position: {x:0, y: 50},
                            style: {fontSize: 20, textAlign: 'center'}
                            }],
                        },
                        footer: {
                            fromBottom: 130,
                            height: 130,
                            contents:  [{
                            type: "Text",
                            value: "Thank You",
                            position: {x:0, y: 50},
                            style: {fontSize: 20}
                            }],
                        
                        }
                    });
                break;
            }
        },
        refreshGrid() {
            this.$refs.dataGrid.refresh();
        },
        openAddRespModal(){
            this.$modal.show('addRespModal');
        },
        openEditRespModal(){
            this.$modal.show('editRespModal');
        },
        editResp(respId) {
            let respDetail = this.responsibilities.filter(resp => resp.id === respId)[0];
            console.log(respDetail);
            this.responsibility = respDetail;
            this.openEditRespModal();
        },
        deleteResp(respId, typ) {
            let resp = false;
            if(typ === 0){
                resp = confirm("Are you sure you want to delete this Responsibility");
            }
            else{
                resp = confirm("Are you sure you want to Re-Add this Responsibility");
            }
            console.log(resp);
           
            if (resp) {
                this.axios
                    .delete(
                        `${configObject.apiBaseUrl}/Responsibilities/Delete/${respId}`,
                        configObject.authConfig
                    )
                    .then(() => {
                        this.getresponsibilities();
                        let msg = "";

                        if(typ === 0){
                            msg = "Responsibility Deleted successfully!"
                        }
                        else{
                            msg = "Responsibility Re-Added successfully!"
                        }

                        this.$toast.open({
                            message: msg,
                            type: "success",
                            duration: 4000
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.$toast.open({
                            message: "unable to perform action",
                            type: "error",
                            duration: 4000
                        });
                    });
            }
        },
        getresponsibilities() {
            this.showLoader = true;
            let grid = this.$refs.dataGrid;
            this.axios
                .get(
                    `${configObject.apiBaseUrl}/Responsibilities`,
                    configObject.authConfig
                )
                .then(response => {
                    let index = 0;
                    response.data.forEach(resp => {
                        index++;
                        resp.index = index;
                        resp.status = resp.deleted ? 'deleted' : 'active'
                    });
                    this.showLoader = false;

                    grid.ej2Instances.setProperties({ dataSource: response.data });
                    this.refreshGrid();
                    this.responsibilities = response.data;
                })
                .catch((error) => {
                    console.log(error);
                    // this.$toast.open({
                    //     message: "unable to load responsibilities",
                    //     type: "error",
                    //     duration: 3000
                    // });
                });
        },
    }
}
</script>

        